'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    menuFilterToIdsFilter: function menuFilterToIdsFilter(_ref) {
        var menuFilter = _ref.menuFilter,
            menu = _ref.menu,
            forceItemIds = _ref.forceItemIds;


        if (forceItemIds) {
            return { type: 'include', ids: forceItemIds };
        }

        if (menuFilter && menuFilter.type == 'dishes') {
            return { type: 'include', ids: menuFilter.ids };
        }

        if (menuFilter && menuFilter.type == 'sections') {
            var sections = _lodash2.default.fromPairs(_lodash2.default.map(_lodash2.default.compact(_lodash2.default.flatten(_lodash2.default.map(menu.sections, 'children'))), function (section) {
                return [section.id, section.itemIds];
            }));

            return {
                type: 'include',
                ids: _lodash2.default.uniq(_lodash2.default.compact(_lodash2.default.flatten(_lodash2.default.extend([], _lodash2.default.filter(sections, function (items, id) {
                    return _lodash2.default.includes(menuFilter.ids, id);
                })))))
            };
        }

        if (menuFilter && menuFilter.type == 'all') {
            return { type: 'exclude', ids: [] };
        }

        return { type: 'include', ids: [] };
    },

    createDishesFilter: function createDishesFilter(_ref2) {
        var ids = _ref2.ids;
        return { type: 'dishes', ids: ids };
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.MenuFilter.js
// module id = 458
// module chunks = 0